import React from 'react';
import styles from '../styles/RealtimeComparisonView.module.css';

/**
 * Weekly Comparison View Component
 * Displays weekly cohort comparison for established users (14+ days)
 *
 * Props:
 * - weeklyComparison: Weekly comparison data from backend
 * - daysActive: Number of days user has been active
 */
function WeeklyComparisonView({ weeklyComparison, daysActive }) {
  if (!weeklyComparison || !weeklyComparison.metrics) {
    return null;
  }

  const { weekLabel, metrics } = weeklyComparison;

  // Define metric display configuration (matching RealtimeComparisonView)
  const metricsData = [
    {
      label: 'Task Completion',
      icon: '✓',
      data: metrics.todos
    },
    {
      label: 'Learning Progress',
      icon: '📚',
      data: metrics.learning
    },
    {
      label: 'Engagement Level',
      icon: '💬',
      data: metrics.conversation
    },
    {
      label: 'Self-Awareness',
      icon: '💡',
      data: metrics.barriers
    }
  ];

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <h2 className={styles.title}>Your Weekly Progress</h2>
        <p className={styles.subtitle}>
          {weekLabel} • Day {daysActive}
        </p>
      </div>

      <div className={styles.metricsGrid}>
        {metricsData.map((metric, index) => {
          if (!metric.data) return null;

          const { percentile, message, rank, cohortSize } = metric.data;

          return (
            <div key={index} className={styles.metricCard}>
              <div className={styles.metricHeader}>
                <span className={styles.metricIcon}>{metric.icon}</span>
                <h3 className={styles.metricLabel}>{metric.label}</h3>
              </div>

              <div className={styles.percentileContainer}>
                <div className={styles.percentileBar}>
                  <div
                    className={`${styles.percentileFill} ${styles[rank]}`}
                    style={{ width: `${percentile}%` }}
                  >
                    <span className={styles.percentileValue}>{percentile}%</span>
                  </div>
                </div>
              </div>

              <div className={styles.metricMessage}>
                <p>{message}</p>
                {cohortSize > 5 && (
                  <p className={styles.cohortSize}>
                    vs. {cohortSize} {cohortSize === 1 ? 'user' : 'users'}
                  </p>
                )}
              </div>
            </div>
          );
        })}
      </div>

      <div className={styles.footer}>
        <p className={styles.footerText}>
          Your progress is compared to other users in your journey week.
          Rankings update automatically as you engage with the platform.
        </p>
      </div>
    </div>
  );
}

export default WeeklyComparisonView;
